import TextField from '@mui/material/TextField';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

import React from 'react';
import { formatLocalDateTimeFromISO } from '../../../Utility/Utility';


interface DatepickerProps {
    label:string,
    name:string,
    value: Date | null | any,
    disabled:boolean,
    onChangeDate(date: Date|null|any , name: string):void
}

const DatePickerComponent:React.FC<DatepickerProps> = ({label, name, value,disabled, onChangeDate}) => {

  const handleChange = (newValue: any | Date | null) => {
    onChangeDate(new Date(newValue?._d).toString(), name);
  };

  const disablePastDates = (date: Date) => {
    // return date < new Date(); // disable dates that are before today
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Set hours, minutes, seconds, and milliseconds to 0 for accurate comparison
    return date < today; // disable dates that are before today
  };

  
  // const updatedValue = new Date(value.getTime() - value.getTimezoneOffset()*60*1000);

  
    return<LocalizationProvider dateAdapter={AdapterMoment}>
    <DateTimePicker
          label={label}
          inputFormat="DD/MM/yy h:mm a"
          value={value}
          disabled={disabled}
          onChange={handleChange}
          shouldDisableDate={disablePastDates}
          renderInput={(params) => <TextField {...params} fullWidth={true} />}
        />
  </LocalizationProvider>
};

export default DatePickerComponent